import { Fragment, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Logo from "../../images/logo.png";
import Img1 from "../../images/globe.png";
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from "react-redux";
import { registerAction, clearErrors } from "../../../redux/actions/userActions";
import Loader from '../../loader/loader';
import { REGISTER_USER_RESET } from '../../../redux/constants/userConstant';


const Signup = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { loading, error, message } = useSelector((state) => state.register);
    const { isAuthenticated } = useSelector((state) => state.verifyEmailStore);

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false)

    // 👇 For password hint display
    const [isPasswordFocused, setIsPasswordFocused] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!name) {
            toast.error("Please enter your name");
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            toast.error("Please enter a valid email address");
            return;
        }

        if (!password) {
            toast.error("Please enter your password");
            return;
        }

        if (password.length < 8) {
            toast.error("Password should contain at least 8 characters");
            return;
        }


        dispatch(registerAction({ name, email, password }));
    };

    useEffect(() => {
        if (message) {
            toast.success(message);
            localStorage.setItem("email", email);
            navigate('/verify-email');
            dispatch({ type: REGISTER_USER_RESET })
        }
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }

        if (isAuthenticated) {
            navigate('/');
        }

        document.title = `REGISTER`;
    }, [error, message, navigate, dispatch, email, isAuthenticated]);



    useEffect(() => {

        document.title = 'SIGN UP'

    }, [])



    return (
        <Fragment>
            {loading ? (
                <Loader />
            ) : (
                <section
                        className="min-h-[100vh] flex items-center justify-center p-[2vmax] login-bg relative overflow-hidden"
                      >
                        
                       
                        <div
                          className="
                            bg-white/95
                            backdrop-blur-sm
                            rounded-[2vmax]
                            w-full
                            lg:w-[80%]
                            min-h-[42vmax]
                            overflow-hidden
                            shadow-[0_2vmax_5vmax_rgba(110,97,255,0.12)]
                            flex
                            flex-col
                            md:flex-row
                            relative
                            z-10
                          "
                        >
                          {/* LEFT SIDE */}
                          <div
                            className="
                              md:w-[48%]
                              bg-[#fafaff]
                              p-[2.5vmax]
                              border-r
                              border-[#f1f1f8]
                              relative
                              flex
                              flex-col
                            "
                          >
                            {/* Logo */}
                            <div
                              className="
                                w-fit
                              "
                            >
                              <img
                                src={Logo}
                                alt="logo"
                                className="w-[12vmax]"
                              />
                            </div>
                
                            {/* Globe */}
                            <div className="flex justify-center items-center flex-1 relative">
                              {/* Orbit Ring */}
                            
                
                             
                              <img
                                src={Img1}
                                alt="globe"
                                className="w-[28vmax] object-contain"
                              />
                            </div>
                
                            {/* Bottom Card */}
                            <div
                              className="
                                bg-white
                                rounded-[1.5vmax]
                                p-[1.5vmax]
                                shadow-[0_1vmax_3vmax_rgba(0,0,0,0.05)]
                                flex
                                items-center
                                gap-[1.2vmax]
                              "
                            >
                              <div
                                className="
                                  w-[4vmax]
                                  h-[4vmax]
                                  rounded-[1vmax]
                                  bg-gradient-to-br
                                  from-violet-400
                                  to-violet-600
                                  flex
                                  items-center
                                  justify-center
                                  text-white
                                  text-[1.8vmax]
                                "
                              >
                                <i className="fa-solid fa-shield-halved"></i>
                              </div>
                
                              <div>
                                <h4 className="font-bold text-[1.2vmax]">
                                  Secure. Smart. Seamless.
                                </h4>
                
                                <p className="text-[1vmax] text-gray-500">
                                  Your gateway to powerful management and insights.
                                </p>
                              </div>
                            </div>
                          </div>

                        <div className="flex w-[100%]  md:w-[44%] mt-[2vmax] pl-[2vmax]">
                            <form
                                className="w-full max-w-[32vmax]"
                                onSubmit={handleSubmit}
                            >
                                <h2
                                    className="
            font-bold
            text-[2.3vmax]
            text-[#111827]
        "
                                >
                                    Welcome
                                </h2>

                                <p
                                    className="text-[1.15vmax] text-gray-500 mt-[0.4vmax]"
                                >
                                    Your Admin Dashboard
                                </p>

                                {/* NAME */}
                                <div className="mt-[3vmax]">
                                    <label className="block text-[1.1vmax] mb-[0.6vmax]">
                                        Name <span className="text-red-500">*</span>
                                    </label>

                                    <div className="relative">
                                        <i
                                            className="
                    fa-regular fa-user
                    absolute
                    left-[1.2vmax]
                    top-1/2
                    -translate-y-1/2
                    text-violet-500
                    text-[1.2vmax]
                "
                                        ></i>

                                        <input
                                            type="text"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            placeholder="Enter your name"
                                            className="
                    w-full
                    pl-[3.5vmax]
                    pr-[1vmax]
                    py-[1vmax]
                    rounded-[0.8vmax]
                    border
                    border-[#dedee8]
                    outline-none
                    focus:border-violet-400
                    text-[1.1vmax]
                "
                                        />
                                    </div>
                                </div>

                                {/* EMAIL */}
                                <div className="mt-[1.5vmax]">
                                    <label className="block text-[1.1vmax] mb-[0.6vmax]">
                                        Email Address <span className="text-red-500">*</span>
                                    </label>

                                    <div className="relative">
                                        <i
                                            className="
                    fa-regular fa-envelope
                    absolute
                    left-[1.2vmax]
                    top-1/2
                    -translate-y-1/2
                    text-violet-500
                    text-[1.2vmax]
                "
                                        ></i>

                                        <input
                                            type="text"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            placeholder="Enter your email"
                                            className="
                    w-full
                    pl-[3.5vmax]
                    pr-[1vmax]
                    py-[1vmax]
                    rounded-[0.8vmax]
                    border
                    border-[#dedee8]
                    outline-none
                    focus:border-violet-400
                    text-[1.1vmax]
                "
                                        />
                                    </div>
                                </div>

                                {/* PASSWORD */}
                                <div className="mt-[1.5vmax]">
                                    <label className="block text-[1.1vmax] mb-[0.6vmax]">
                                        Password <span className="text-red-500">*</span>
                                    </label>

                                    <div className="relative">
                                        <i
                                            className="
                    fa-solid fa-lock
                    absolute
                    left-[1.2vmax]
                    top-1/2
                    -translate-y-1/2
                    text-violet-500
                    text-[1.2vmax]
                "
                                        ></i>

                                        <input
                                            type={showPassword ? "text" : "password"}
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            onFocus={() => setIsPasswordFocused(true)}
                                            onBlur={() => setIsPasswordFocused(false)}
                                            placeholder="Enter your password"
                                            className="
                    w-full
                    pl-[3.5vmax]
                    pr-[4vmax]
                    py-[1vmax]
                    rounded-[0.8vmax]
                    border
                    border-[#dedee8]
                    outline-none
                    focus:border-violet-400
                    text-[1.1vmax]
                "
                                        />

                                        <button
                                            type="button"
                                            onClick={() => setShowPassword(prev => !prev)}
                                            className="
                    absolute
                    right-[1.2vmax]
                    top-1/2
                    -translate-y-1/2
                    text-[1.2vmax]
                "
                                        >
                                            <i
                                                className={`fa-solid ${showPassword
                                                        ? "fa-eye-slash"
                                                        : "fa-eye"
                                                    }`}
                                            ></i>
                                        </button>
                                    </div>

                                    {isPasswordFocused && (
                                        <div
                                            className={`
                    text-right
                    mt-[0.5vmax]
                    text-[0.95vmax]
                    transition-all
                    duration-300
                    ${password.length >= 8
                                                    ? "text-green-500"
                                                    : "text-red-500"
                                                }
                `}
                                        >
                                            Password <i className="fa-solid fa-angle-right"></i> 8 Characters
                                        </div>
                                    )}
                                </div>

                                {/* SIGNUP BUTTON */}
                                <button
                                    type="submit"
                                    className="
            w-full
            mt-[2vmax]
            py-[1vmax]
            rounded-[1vmax]
            text-white
            font-bold
            text-[1.25vmax]
            bg-gradient-to-r
            from-violet-600
            to-violet-400
            shadow-[0_1vmax_3vmax_rgba(124,58,237,0.35)]
            flex
            items-center
            justify-center
            gap-[1vmax]
            transition-all
            duration-300
            hover:scale-[0.98]
        "
                                >
                                    Sign Up

                                    <span
                                        className="
                w-[2.2vmax]
                h-[2.2vmax]
                rounded-full
                bg-white/20
                flex
                items-center
                justify-center
            "
                                    >
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </button>

                                {/* LOGIN LINK */}
                                <div
                                    className="
            text-center
            mt-[2vmax]
            text-[1.1vmax]
        "
                                >
                                    Already have an account?

                                    <Link
                                        to="/login"
                                        className="
                ml-[0.3vmax]
                text-violet-600
                font-semibold
            "
                                    >
                                        Sign In
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>
            )}
        </Fragment>
    );
};

export default Signup;
